import { render } from "./ContentItem.vue?vue&type=template&id=ff542316&scoped=true"
import script from "./ContentItem.vue?vue&type=script&lang=js"
export * from "./ContentItem.vue?vue&type=script&lang=js"

import "./ContentItem.vue?vue&type=style&index=0&id=ff542316&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ff542316"

export default script